import { render, staticRenderFns } from "./Presses.vue?vue&type=template&id=74bd3f54&"
import script from "./Presses.vue?vue&type=script&lang=js&"
export * from "./Presses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports